import { render, staticRenderFns } from "./ConfirmacaoCadastro.vue?vue&type=template&id=e44aa962&scoped=true"
import script from "./ConfirmacaoCadastro.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoCadastro.vue?vue&type=script&lang=js"
import style0 from "./ConfirmacaoCadastro.vue?vue&type=style&index=0&id=e44aa962&prod&lang=scss&scoped=true"
import style1 from "./ConfirmacaoCadastro.vue?vue&type=style&index=1&id=e44aa962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e44aa962",
  null
  
)

export default component.exports